export default "__VITE_ASSET__Afx$4WP8__$_?nuxt_component=async&nuxt_component_name=IconGaragesPicto&nuxt_component_export=default__"